export const currencyFormat = ({
  locales = 'nl-NL',
  currency = 'EUR',
  amount,
  minimumFractionDigits = 2,
  maximumFractionDigits,
}: {
  locales?: string;
  currency?: string;
  amount: number | bigint;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}) => {
  return new Intl.NumberFormat(locales, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits,
    maximumFractionDigits:
      maximumFractionDigits ?? Math.max(minimumFractionDigits, 2),
  }).format(amount);
};
